export default {
  setApi(state, api) {
    state.api = api;
  },

  setMap(state, map) {
    state.map = map;
  },
};
